/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrPostSubmitRequest
 */
export interface RttrPostSubmitRequest {
    /**
     * Full URL to the
     * @type {string}
     * @memberof RttrPostSubmitRequest
     */
    postUrl: string;
    /**
     * 
     * @type {string}
     * @memberof RttrPostSubmitRequest
     */
    platform: RttrPostSubmitRequestPlatformEnum;
}


/**
 * @export
 */
export const RttrPostSubmitRequestPlatformEnum = {
    tiktok: 'tiktok',
    instagram: 'instagram',
    facebook: 'facebook'
} as const;
export type RttrPostSubmitRequestPlatformEnum = typeof RttrPostSubmitRequestPlatformEnum[keyof typeof RttrPostSubmitRequestPlatformEnum];


/**
 * Check if a given object implements the RttrPostSubmitRequest interface.
 */
export function instanceOfRttrPostSubmitRequest(value: object): value is RttrPostSubmitRequest {
    if (!('postUrl' in value) || value['postUrl'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function RttrPostSubmitRequestFromJSON(json: any): RttrPostSubmitRequest {
    return RttrPostSubmitRequestFromJSONTyped(json, false);
}

export function RttrPostSubmitRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrPostSubmitRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'postUrl': json['postUrl'],
        'platform': json['platform'],
    };
}

export function RttrPostSubmitRequestToJSON(json: any): RttrPostSubmitRequest {
    return RttrPostSubmitRequestToJSONTyped(json, false);
}

export function RttrPostSubmitRequestToJSONTyped(value?: RttrPostSubmitRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'postUrl': value['postUrl'],
        'platform': value['platform'],
    };
}

